import './error.scss';

// Assets
import { ReactComponent as ErrorIcon } from '../../asset/error-page.svg';

const Error = ({ code }) => {
	return (
		<div className="error">
			<ErrorIcon className="error__icon" />
			<p className="error__title">No data for this tracking number...</p>
			<p className="error__description">
				We are unable to fetch information related to tracking number {code?.toUpperCase()}. There could be few
				reasons: package carrier is not supported or tracking number is invalid. To be sure, try once more after
				some time.
			</p>
		</div>
	);
};

export default Error;
